import React, {useEffect} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

function SpO2({ data, ranges=[]}) {
    const history = data?.history || [];
    const current = data.current;

    
    // Extract values for min/max calculation
    const values = history.map(item => item.value);
    
    const options = {   
        chart: {
            type: 'line',
            height: 260,
        },
        title: {
            text: ''
        },
        xAxis: {
            categories: history.map(item => item.date),
            labels: {
                rotation: 0
            }
        },
        yAxis: {
            title: {
                text: 'SpO2',
                enabled: false
            },
            labels: { 
                enabled: false 
            },
            minorGridLineWidth: 0,
            gridLineWidth: 0,
            alternateGridColor: null,
            plotLines: ranges?.map((range, index) => ({
                value: range.value,
                color: range.color,
                width: range.width,
                dashStyle: range.dashStyle,
                zIndex: range.zIndex,
                label: {
                    text: `${range.label.text}`,
                    align: 'left',
                    x: 10,
                    y: 20,
                    style: {
                        color: range.color
                    }
                }
            })),
            min: Math.min(...values) - 5,
            max: Math.max(...values) + 10
        },
        series: [{
            name: 'SpO2',
            data: values,
            dataLabels: {
                enabled: true,  // Enable data labels on the points
                format: '{y}',
            },
            color: '#4A90E2',
            zoneAxis: 'y',
            zones: ranges?.map(range => ({
                value: range.value,
                color: range.color || range.lineColor
            })),
        }],
        tooltip: {
            valueSuffix: ' %'
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false
        },
        accessibility: {
            enabled: false
        },
    };

    return (
        <div className="col-md-12">
            <div className="member-engagement mb-3">
                <h1 className='dashboard-graph-title mb-2'>
                    <span>SpO2</span>
                </h1>
                <h1 className="card-title1">
                    {data?.current ? (
                        <>
                            {data.current} <span>% ({data?.currentObservation})</span>
                        </>
                    ) : (
                        <span>No data available</span>
                    )}
                </h1>
                <div className='mt-3'>
                    {data?.history?.length > 0 ? (
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={options}
                        />
                    ) : (
                        <div className="text-center p-4">
                            <div className="alert alert-info">
                                <i className="fa fa-info-circle me-2"></i>
                                No SpO2 readings available
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SpO2; 